// @flow

import type {FormType} from '@/types'

import React from 'react'
import {connect} from 'react-redux'

import PortfolioForm from '@/views/forms/portfolio'
import EditCompanyForm from '@/views/forms/edit-company'
import ExportForm from '@/views/forms/export'
import UploadFile from '@/views/forms/upload-file'
import PortfolioMultiSelect from '@/views/forms/portfolio-multi-select'
import SharePortfolioForm from '@/views/forms/share-portfolio/index'

type Props = {
  id: ?string,
  type: ?FormType,
}

export const RawForm = ({id, type}: Props) => {
  switch (type) {
    case 'add-portfolio':
      return <PortfolioForm />
    case 'edit-portfolio':
      return <PortfolioForm id={id} />
    case 'edit-company':
      return <EditCompanyForm id={id}/>
    case 'export':
      return <ExportForm />
    case 'upload-file-import':
      return <UploadFile type='import'/>
    case 'upload-file-sync':
      return <UploadFile type='sync'/>
    case 'portfolio-multi-select':
      return <PortfolioMultiSelect includeAll={true} />
    case 'share-portfolio':
      return <SharePortfolioForm />
    default:
      return null
  }
}

const mapStateToProps = (state) => ({
  id: state.form.id,
  type: state.form.type,
})

export default connect(
  mapStateToProps,
)(RawForm)



// WEBPACK FOOTER //
// ./src/views/modals/form.js